<div class="wrap">
    <div class="dash">




        <form class="camera_select" [formGroup]="choiceDateForm" (ngSubmit)="onSubmit(false)">
            <mat-form-field appearance="outline">
                <mat-label>Du</mat-label>
                <input matInput [matDatepicker]="from" formControlName="from">
                <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
                <mat-datepicker #from></mat-datepicker>
            </mat-form-field>
            <span>-</span>
            <mat-form-field appearance="outline">
                <mat-label>Au</mat-label>
                <input matInput [max]="today" [matDatepicker]="to" formControlName="to">
                <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                <mat-datepicker #to></mat-datepicker>
            </mat-form-field>
        </form>



        <agm-map [latitude]='lat' [longitude]='lng'>
            <agm-marker-cluster
                imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
                <agm-marker *ngFor="let markerWaste of markersWaste" [latitude]="markerWaste.lat"
                    [longitude]="markerWaste.lng" [iconUrl]="markerWaste.iconUrl">
                    <agm-info-window #infoWindow>
                        {{ markerWaste.label }}
                    </agm-info-window>
                </agm-marker>
            </agm-marker-cluster>
        </agm-map><br>

        <table [dataSource]="dataSource" mat-table class="mat-elevation-z8">



            <ng-container matColumnDef="camera">
                <th mat-header-cell *matHeaderCellDef> camera </th>
                <td mat-cell *matCellDef="let element"> {{element.camera}} </td>
            </ng-container>

            <ng-container matColumnDef="batterie">
                <th mat-header-cell *matHeaderCellDef> battery
                </th>
                <td mat-cell *matCellDef="let element"> {{element.batterie}} </td>
            </ng-container>

            <ng-container matColumnDef="infraction">
                <th mat-header-cell *matHeaderCellDef> Nombre d'infractions </th>
                <td mat-cell *matCellDef="let element"> {{element.infraction}} </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            aria-label="Select page">
        </mat-paginator>


    </div>
</div>